// extracted by mini-css-extract-plugin
module.exports = {"logo":"drawer_logo__COlFI","header":"drawer_header__b8T1B"};